import React, { useState } from 'react';

const deepEqual = (a, b) => {
	if (a === b) return true;

	if (typeof a !== typeof b) return false;

	if (a && b && typeof a === 'object') {
		const aKeys = Object.keys(a);
		const bKeys = Object.keys(b);
		if (aKeys.length !== bKeys.length) return false;

		for (const key of aKeys) {
			if (!deepEqual(a[key], b[key])) return false;
		}

		return true;
	}

	return false;
};

export default (newObject, originalObject) => {
	const changed = {};

	for (const key in newObject) {
		if (!deepEqual(newObject[key], originalObject[key])) {
			if (newObject[key]) {
				changed[key] = newObject[key];
			}
		}
	}
	return [!(JSON.stringify(changed) === '{}'), changed];
};
